import { render, staticRenderFns } from "./SinonimiIcdxComponent.vue?vue&type=template&id=66653781"
import script from "./SinonimiIcdxComponent.vue?vue&type=script&lang=js"
export * from "./SinonimiIcdxComponent.vue?vue&type=script&lang=js"
import style0 from "./SinonimiIcdxComponent.vue?vue&type=style&index=0&id=66653781&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports